import * as React from "react"
import {useSignal} from "@preact/signals-react";
import {Grid, Typography} from "@mui/material";
import {TabsSeeker} from "@ui-seeker/core";
import {formatDate} from "@ui-seeker/utils";

import {ImageSkuBlock, LabelCountry, SkuLinkLabel, HierarchicalTextBlock} from "@components";
import {ActualListBlock} from "../@components";
import {AdminProductReviewDetailsDrawerContentTabFeatures, AdminProductReviewDetailsDrawerContentTabDescription} from "./Tabs";
import AdminProductReviewDetailsDrawerContentTabInternalInfo from "./Tabs/InternalInfo";
import AdminProductReviewDetailsDrawerContentTabAttributes from "./Tabs/Attributes";


export default function AdminProductReviewDetailsDrawerContent({data, isModalVideo, multimediaCarousel, multimediaCarouselInitPos}) {
	const displayInfoID = useSignal(0)

	const {
		brandRaw, country, retailer, date, thumbnail, productName, ean, productURL, actualPrice, listPrice,
		currency, category, ...extraData
	} = data

	return <Grid container spacing={2}>
		<Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
			<Typography variant="h5">{brandRaw}</Typography>
			<LabelCountry country={country} label={retailer} />
			<Typography>{formatDate(date, { isString: true })}</Typography>
		</Grid>

		<Grid item xs={12}>
			<ImageSkuBlock
				hideName
				imageURL={thumbnail}
				name={productName}
				height={300}
			/>
		</Grid>

		<Grid item xs={12}>
			<SkuLinkLabel url={productURL} skuName={productName} variant="h5" maxWidth={400} />
			<HierarchicalTextBlock title="EAN: " titleValue={ean || '--'} />
			<HierarchicalTextBlock title="Category: " titleValue={category || '--'} />
		</Grid>
		<Grid item xs={12}>
			<ActualListBlock actualPrice={actualPrice} listPrice={listPrice} currency={currency} variant="subtitle1" />
		</Grid>

		<Grid item xs={12}>
			<TabsSeeker
				showTabID={displayInfoID.value}
				onChange={(_, newValue) => displayInfoID.value = newValue}
				tabs={[
					{ label: 'Features', value: 0 },
					{ label: 'Description', value: 1 },
					{ label: 'Internal Info', value: 2 },
					{ label: 'Attributes', value: 3 },
				]}
			/>
		</Grid>

		<Grid item xs={12}>
			{ displayInfoID.value === 0 && <AdminProductReviewDetailsDrawerContentTabFeatures {...extraData} currency={currency} /> }
			{ displayInfoID.value === 1 && 
				<AdminProductReviewDetailsDrawerContentTabDescription 
					isModalVideo={isModalVideo} 
					multimediaCarousel={multimediaCarousel}
					multimediaCarouselInitPos={multimediaCarouselInitPos}
					{...extraData} 
				/> 
			}
			{ displayInfoID.value === 2 && <AdminProductReviewDetailsDrawerContentTabInternalInfo {...extraData} /> }
			{ displayInfoID.value === 3 && <AdminProductReviewDetailsDrawerContentTabAttributes {...extraData} /> }
		</Grid>
	</Grid>
}